import axios from "axios";

// Empty string = same origin (backend serves the SPA). Avoids "/undefined/api/...".
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("algo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.method?.toLowerCase() === "get") {
    config.params = { ...config.params, _ts: Date.now() };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("algo_token");
      localStorage.removeItem("algo_user");
      const p = window.location.pathname;
      if (!p.startsWith("/login") && !p.startsWith("/register") && !p.startsWith("/broker-callback")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

